module.exports = __webpack_public_path__ + "static/img/cargo-content-1-2.3f7aeb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cargo-content-1-2.png
// module id = E7yJ
// module chunks = 0